import {
  takeLatest, put,
} from 'redux-saga/effects';

import ArticleService from '../../../services/ArticleService';
import DocumentService from '../../../services/DocumentService';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';

import {
  getImageListRequest,
  getImageListSuccess,
  getImageListFail,
  getVideoListRequest,
  getVideoListSuccess,
  getVideoListFail,
  getDocumentListSuccess,
  getDocumentListRequest,
  getDocumentListFail,
  getArticleDocumentPagesRequest,
  getArticleDocumentPagesFail,
  getArticleDocumentPagesSuccess,
  getAudioListRequest,
  getAudioListSuccess,
  getAudioListFail,
} from './actions';


function* getImages({ payload }: ReturnType<typeof getImageListRequest>) {
  try {
    const articles = yield apiCall(ArticleService.list, payload);
    yield put(getImageListSuccess(articles));
  } catch (e) {
    yield put(getImageListFail());
    yield put(notify(getErrorNotification(e)));
  }
}

function* getVideos({ payload }: ReturnType<typeof getVideoListRequest>) {
  try {
    const videos = yield apiCall(ArticleService.list, payload);
    yield put(getVideoListSuccess(videos));
  } catch (e) {
    yield put(getVideoListFail());
    yield put(notify(getErrorNotification(e)));
  }
}

function* getAudios({ payload }: ReturnType<typeof getAudioListRequest>) {
  try {
    const audios = yield apiCall(ArticleService.list, payload);
    yield put(getAudioListSuccess(audios));
  } catch (e) {
    yield put(getAudioListFail());
    yield put(notify(getErrorNotification(e)));
  }
}

function* getDocuments({ payload }: ReturnType<typeof getDocumentListRequest>) {
  try {
    const videos = yield apiCall(ArticleService.list, payload);
    yield put(getDocumentListSuccess(videos));
  } catch (e) {
    yield put(getDocumentListFail());
    yield put(notify(getErrorNotification(e)));
  }
}

function* getDocumentPages({ payload }: ReturnType<typeof getArticleDocumentPagesRequest>) {
  try {
    const response = yield apiCall(DocumentService.getPageInfo, payload);
    yield put(getArticleDocumentPagesSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getArticleDocumentPagesFail());
  }
}

export default [
  takeLatest(getImageListRequest.type, getImages),
  takeLatest(getVideoListRequest.type, getVideos),
  takeLatest(getAudioListRequest.type, getAudios),
  takeLatest(getDocumentListRequest.type, getDocuments),
  takeLatest(getArticleDocumentPagesRequest.type, getDocumentPages),
];
